import { render, staticRenderFns } from "./FileUploadsriskmanagement.vue?vue&type=template&id=6da12c55"
import script from "./FileUploadsriskmanagement.vue?vue&type=script&lang=js"
export * from "./FileUploadsriskmanagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports